import React, { useMemo, useRef, useEffect } from 'react';
import deepEqual from 'lodash/isEqual';

import type {
    AdvertContextType,
    AD_UNIT_PAGE_TYPE,
    AD_UNIT_SECTION,
    AD_UNIT_SECTION_NEW,
    DfpTargeting,
    DFP_AD_UNIT,
    ZPG_DFP_NETWORK
} from './types';

type DeprecatedProps = {
    value: {
        adUnitCode?: DFP_AD_UNIT.DEFAULT;
        dfpNetworkId?: ZPG_DFP_NETWORK.ID;
        targeting: DfpTargeting;
        showPlaceHolderContent?: boolean;
        initialState?: AdvertContextType;
        debugMode?: boolean;
        pageNumber?: number;
        adBridgPage?: AD_UNIT_SECTION;
        adBridgPageNew?: AD_UNIT_SECTION_NEW;
        pageType?: AD_UNIT_PAGE_TYPE;
        delayInit?: boolean;
    };
    dispatchOverride?: unknown;
};

export const AdbridgWrapper: React.FC<
    React.PropsWithChildren<
        {
            page?: string;
        } & DeprecatedProps
    >
> = ({
    children,
    value: { targeting, adBridgPage, adBridgPageNew: channel, pageType }
}) => {
    const targetingRef = useRef<DfpTargeting>(targeting);
    const signalRef = useRef<number>(0);

    /* See: https://github.com/kentcdodds/use-deep-compare-effect */
    if (!deepEqual(targeting, targetingRef.current)) {
        targetingRef.current = targeting;
        signalRef.current += 1;
    }

    const __html = useMemo(
        () => JSON.stringify(targetingRef.current),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [signalRef.current]
    );

    useEffect(() => {
        let ignore = false;
        if (!ignore && signalRef.current !== 0) {
            const event = new Event('adrefresh');
            window.dispatchEvent(event);
        }
        return () => {
            ignore = true;
        };
    }, [__html, signalRef]);

    return (
        <>
            {children}
            <script
                id="__ZAD_TARGETING__"
                data-adbridgpage={adBridgPage}
                data-adbridgchannel={channel}
                data-adbridgpagetype={pageType}
                dangerouslySetInnerHTML={{ __html }}
            ></script>
        </>
    );
};
